import {noop} from "lodash";
import {
    User_WHMp_Config_Info, User_WHMp_Config_List,
    User_WHMp_Config_Modify,
    User_WHMp_Config_Save
} from "../../config";
import api from "../../api/api";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
export const UserWHMpActionType = {
    USER_WHMP_CFG_INFO:'USER_WHMP_CFG_INFO',
    USER_WHMP_CFG_LIST:'USER_WHMP_CFG_LIST',
    USER_WHMP_CFG_RESET:'USER_WHMP_CFG_RESET',
    USER_WHMP_CFG_LIST_RESET:'USER_WHMP_CFG_LIST_RESET'
}
export const userWHMpCfgInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.WarehouseMappingInfo)) return null;
        const url = `${User_WHMp_Config_Info}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:UserWHMpActionType.USER_WHMP_CFG_INFO,
                payload:response.data
            })
            onSuccess(response.data)
        } else {
            onError(response.data.msg)
        }
    } catch (e) {
        onError(e.message)
    }
}

export const userWHMpCfgList = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.WarehouseMappingList)) return null;
        const url = `${User_WHMp_Config_List}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:UserWHMpActionType.USER_WHMP_CFG_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg)
        }
    } catch (e) {
        onError(e.message)
    }
}



export const userWHMpCfgModify = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.WarehouseMappingUpdate)) return null;
        const url = `${User_WHMp_Config_Modify}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("WarehousePage.WarehouseMappings.Edit User WHMp Config Successfully")
        } else {
            onError(response.data.msg)
        }
    } catch (e) {
        onError(e.message)
    }
}
export const userWHMpCfgSave = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.WarehouseMappingSave)) return null;
        const url = `${User_WHMp_Config_Save}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("WarehousePage.WarehouseMappings.Add User WHMp Config Successfully")
        } else {
            onError(response.data.msg)
        }
    } catch (e) {
        onError(e.message)
    }
}
export const userWHMpCfgReset = (onSuccess = noop, onError = noop) => async dispatch => {
    try {
        dispatch({
            type:UserWHMpActionType.USER_WHMP_CFG_RESET,
            payload:{}
        })
    } catch (e) {
        onError(e.message)
    }
}

export const resetUserWHMpCfgList = (onSuccess = noop, onError = noop) => async dispatch => {
    try {
        dispatch({
            type:UserWHMpActionType.USER_WHMP_CFG_LIST_RESET,
            payload:{}
        })
    } catch (e) {
        onError(e.message)
    }
}